import { timeFormat } from "d3";

export const ChartTicks = {
  setTicks({
    axisPosition,
    axisValue,
    coordinate,
    tickCount,
    tickSize,
    tickFormat,
    transformX = 0,
    transformY = 0
  }) {
    this.svg[coordinate] = axisPosition(this.svg[axisValue])
      .ticks(tickCount)
      .tickSize(tickSize)
      .tickFormat(d => timeFormat(tickFormat)(this.data[d]));

    const g = this.svg
      .append("g")
      .attr("class", "ticks")
      .attr("transform", "translate(" + transformX + "," + transformY + ")")
      .call(this.svg[coordinate]);
    this.g = g;
  }
};
